import {
  Box,
  FlatList,
  HStack,
  Header,
  Icon,
  Pressable,
  Text,
  VStack,
} from '@rbilabs/universal-components';

import loyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import { ProgressMeter } from 'components/progress-meter';
import { primitive } from 'styles/constants/primitives';
import { delayUnmountHOC } from 'utils/delay-unmount-hoc';

const RewardContainer = Box.withConfig({});
const CATEGORY_HEADER_HEIGHT = 44;
const METER_CONTAINER_WIDTH = '375px';

export const DelayedUnmountRewardContainer = delayUnmountHOC(RewardContainer);

export const RewardCategoryAccordion = VStack.withConfig<{
  open: boolean;
  categoryHeight: number;
  isCurrentSelection: boolean;
}>(p => ({
  height: (p.open ? p.categoryHeight : 0) + CATEGORY_HEADER_HEIGHT,
}));

export const CategoryHeader = VStack.withConfig({
  justifyContent: 'center',
  height: CATEGORY_HEADER_HEIGHT,
  borderBottomWidth: 1,
  borderBottomColor: Styles.color.grey.four,
  background: Styles.color.white,
});

export const AccordionTrigger = Pressable.withConfig({
  flexDir: 'row',
  alignItems: 'center',
  alignContent: 'space-between',
  paddingX: 4,
  flexGrow: 1,
});

export const CategoryImage = Picture.withConfig({
  height: '$7',
  width: '$7',
  marginRight: '$1',
});

export const CategoryLabel = Header.withConfig({
  fontSize: 'xl',
  margin: 0,
  flexGrow: 2,
});

export const LoyaltyRewardsTitleContainer = Box.withConfig({
  bgColor: primitive.$white,
});

export const LoyaltyRewardsTitle = Header.withConfig({
  variant: 'headerTwo',
  margin: 0,
  padding: 4,
});

export const LoyaltyLoaderContainer = Box.withConfig({
  height: '100%',
  minHeight: '$80',
  justifyContent: 'center',
});

export const ChallengeContainer = Box.withConfig({
  margin: '$4',
});

/* Loyalty Redesign Phase 1 Styles */

export const LoyaltyRewardsListTitleContainer = Box.withConfig({
  marginLeft: '$4',
});

export const LoyaltyRewardsListTitle = Header.withConfig({
  variant: 'headerOne',
});

export const RewardCategoryContainer = Pressable.withConfig<{
  locked: boolean;
}>(p => ({
  flexDir: 'column',
  paddingBottom: '$4',
  flex: 1,
  background: p.locked ? Styles.color.grey.nine : '',
}));

export const RewardCategoryHeader = VStack.withConfig({
  justifyContent: 'center',
  height: CATEGORY_HEADER_HEIGHT,
  paddingX: '$4',
  flexDir: 'row',
  alignItems: 'center',
  alignContent: 'space-between',
});

export const RewardCategoryCarouselContainer = Box.withConfig({
  flex: 1,
  flexDir: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  paddingX: '$4',
});

export const RewardCategoryFlatList = FlatList.withConfig({
  contentContainerStyle: {
    paddingRight: 24,
  },
  showsHorizontalScrollIndicator: false,
  horizontal: true,
  paddingLeft: '$4',
  flex: 1,
});

export const RewardCategoryMeterContainer = Box.withConfig({
  borderTopWidth: '1',
  borderTopColor: Styles.color.grey.four,
  backgroundColor: Styles.color.grey.nine,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '$4',
  paddingTop: '$8',
  paddingBottom: '$4',
});

export const MeterContainer = Box.withConfig({
  width: METER_CONTAINER_WIDTH,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  paddingX: '$8',
});

export const StyledProgressMeter = ProgressMeter.withConfig({
  borderWidth: '0',
  background: primitive.$white,
});

export const PointsNeededContainer = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
});

export const PointsNeededText = Text.withConfig({
  fontSize: 'sm',
  fontWeight: 'bold',
  marginRight: '$1',
});

export const PointsNeededDescription = Text.withConfig({
  fontSize: 'xs',
});

export const StyledPointsIcon = loyaltyPointsIcon.withConfig({
  width: '$4',
  height: '$4',
  marginRight: '$1',
});

export const StyledRewardLock = Icon.withConfig({
  variant: 'locked',
  size: '$5',
});

export const PointsNeededLockIcon = StyledRewardLock.withConfig({
  size: '$5',
  color: primitive.bk.$bbqBrown,
});
